import React from 'react';
import Button from '@material-ui/core/Button';
import ReactJson from 'react-json-view';
import AmplifyWrapper from '../../../service/auth.service';
import { connect } from 'react-redux';
import './Dashboard.scss';

class Dashboard extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			callResponse: {},
			userIsLoggedIn: false,
			user: {},
			code: ''
		};
	}

	testCall() {
		console.log(this.state.user.signInUserSession);
		AmplifyWrapper.makeApiRequest('get', 'MyExpressServer', '/myfirstapi', {
			headers: {
				Authorization: this.state.user.signInUserSession.accessToken.jwtToken
				//'eyJraWQiOiI0TGNtRW1vcEJwZlpiM0JDNkViWmozXC9Rd3BsS1h0RndzM2RCSDJMVlhhOD0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJlYTM0ZjZlMC1jMGIxLTQzZDQtYWY4MC02NGI1NWZlM2Y4MzQiLCJldmVudF9pZCI6IjllODFiNzA2LTFhYjYtNDliMC04ZDQ0LWU0YjFkMzNmYjA0ZiIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE1Nzk2Mzg2NDAsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC5ldS1jZW50cmFsLTEuYW1hem9uYXdzLmNvbVwvZXUtY2VudHJhbC0xX0NpNENwcGhrMiIsImV4cCI6MTU3OTY0MjI0NSwiaWF0IjoxNTc5NjM4NjQ1LCJqdGkiOiI1M2ExMjVlZC1kNmY0LTQ2NzEtOGNhMS0zNDE3YWE1ZTQ5OGMiLCJjbGllbnRfaWQiOiIyMDA5MXBkNnBtNzAwaWRkcDhuc2p1dTFobiIsInVzZXJuYW1lIjoiTWlrZSJ9.LslNGlwZbPK0BIMlufWuxohPpwNTIBzbElMCwMCCVLN-H9jhwNH1RjbokldtbXiw3B-Q8NFtKMxoFZMOkU5noaBzedmBV6_fbyhOSgASQCkOMOD-m44Wy_qSgLxsBXdQl6sz2JfYbvRofwpu3lf-bJ1fMQppe80wrtdJE0RjEfLL7rb0JihPXpG2tTNOqc70ouZYwQbkCVe5B3Ft5fMqgTEWQoL2QM_DmywJsBaRldocPQG5VLc8WRhvcmXnzjBnNFMnM9teW8upOaYBqeb_z9fy1e637HA0pfU36tuicUewhT7IFhVfGQ3omNeMBf7dUl-L5CIMJgB6iruxFtDfTQ'
			},
			response: true // OPTIONAL (return the entire Axios response object instead of only response.data)
		})
			.then(response => {
				console.log(response);
				this.setState({ callResponse: response });
				//alert('Success. See console');
			})
			.catch(error => {
				console.log(error);
				alert('Error. See console');
			});
	}

	componentDidMount() {
		AmplifyWrapper.currentAuthenticatedUser()
			.then(user => {
				this.setState({ user, userIsLoggedIn: true });
			})
			.catch(err => {
				this.setState({ userIsLoggedIn: false });
			});
	}

	renderDashboard() {
		return this.state.userIsLoggedIn === true
			? <div>
					<h2>Currently logged in user (AWS Cognito)</h2>
					<ReactJson src={this.state.user} theme="monokai" collapsed />

					<br />
					<hr />
					<br />
					<h2>Make an authenticated call to nodejs server</h2>
					<Button className="btnAction" variant="contained" color="primary" onClick={this.testCall.bind(this)}>
						submit
					</Button>

					<br />
					<h2>Response</h2>
					<ReactJson src={this.state.callResponse} theme="monokai" collapsed />
				</div>
			: null;
	}

	render() {
		return (
			<div className="Dashboard">
				<div className="container">
					<h1>Dashboard</h1>
					{this.renderDashboard()}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.login.user
	};
};

const mapDispatchToProps = dispatch => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
